import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FileDto } from 'src/app/models/FileDto';

@Pipe({
  name: 'fileFilter',
  standalone: true
})
export class FileFilterPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  /**
   * Filters an array of files based on a search term.
   * The search term is matched against the file's original name, creation date, and creator's first and last names.
   *
   * @param {FileDto[]} files - The array of files to filter.
   * @param {string} searchTerm - The term to search for in the file properties.
   * @returns {FileDto[]} - The filtered array of files.
   */
  transform(files: FileDto[], searchTerm: string): FileDto[] {
    // Check if files or searchTerm are not provided
    if (!files || !searchTerm) {
      return files;
    }

    // Convert the search term to lowercase for case-insensitive comparison
    const lowerSearchTerm = searchTerm.toLowerCase();

    // Filter the files array based on the search term
    return files.filter((file) => {
      // Transform the file's creation date to a formatted string
      const createdAt = this.datePipe.transform(
        file.createdAt,
        'dd.MM.yyyy HH:mm:ss'
      );

      // Check if the file has a creator
      if (file.createdBy) {
        return (
          // Check if the original name includes the search term
          file.originalname.toLowerCase().includes(lowerSearchTerm) ||
          // Check if the formatted creation date includes the search term
          (createdAt && createdAt.includes(lowerSearchTerm)) ||
          // Check if the creator's first name includes the search term
          (file.createdBy.firstname &&
            file.createdBy.firstname.toLowerCase().includes(lowerSearchTerm)) ||
          // Check if the creator's last name includes the search term
          (file.createdBy.lastname &&
            file.createdBy.lastname.toLowerCase().includes(lowerSearchTerm))
        );
      }

      // Check if the original name or formatted creation date includes the search term
      return (
        file.originalname.toLowerCase().includes(lowerSearchTerm) ||
        (createdAt && createdAt.includes(lowerSearchTerm))
      );
    });
  }
}
